/* eslint-disable no-template-curly-in-string */

const messages = {
  required: '必填项',
  number: '应该是 Number 类型',
  string: '应该是 String 类型',
  boolean: '应该是 Boolean 类型',
  object: '应该是 Object 类型',
  array: '应该是 Array 类型',
  max: '不能大于 ${limit}',
  min: '不能小于 ${limit}',
  maxLength: '超出 ${limit} 字符限制',
  minLength: '不能少于 ${limit} 字符',
  maxChineseLength: '超出 ${limit} 中文限制',
  minChineseLength: '不能少于 ${limit} 中文',
  url: '链接不合法',
}

export function getMessage(key, options = {}) {
  const msg = (options.msg ?? messages[key])
    .replace('${limit}', options.limit)

  return msg
}
